export default __webpack_public_path__ + "static/media/bottomsheet-styles.9a134576.png";